import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { createUseStyles, Button } from '@Sage/hoi-poi-ui';
import classnames from 'classnames';

import { useWeb5Context } from 'lib/Web5Context';

import styles from './styles';
const useStyles = createUseStyles(styles, 'FiltersButton');

const getNumberFilters = (values) =>
    Object.keys(values).reduce(
        (acc, key) =>
            acc +
            ((values[key] !== '' &&
                values[key] !== undefined &&
                values[key] !== null &&
                !Array.isArray(values[key]) &&
                typeof values[key] !== 'boolean') ||
            (typeof values[key] === 'boolean' && values[key] !== false) ||
            values[key]?.length
                ? 1
                : 0),
        0,
    );
const FiltersButton = ({ haveFilters, numberFilters, openFilters }) => {
    const classes = useStyles();
    const { t } = useWeb5Context();

    const classNames = classnames('filters__toolbar__filter-btn', classes.FiltersButton);

    if (haveFilters)
        return (
            <Button
                type="secondary"
                icon="filterListActive"
                onClick={openFilters}
                className={classNames}
            >
                {t('label_filters_button', [numberFilters])}
            </Button>
        );

    return (
        !haveFilters && (
            <Button type="terciary" icon="filterList" onClick={openFilters} className={classNames}>
                {t('cfm_action_filter')}
            </Button>
        )
    );
};

FiltersButton.propTypes = {
    haveFilters: PropTypes.bool,
    openFilters: PropTypes.func,
    numberFilters: PropTypes.number,
};

export default memo(FiltersButton);

export { getNumberFilters };
